import { cn } from '@shared/lib/utils';
import { ClassValue } from 'clsx';
import React from 'react';

type HeadingVariant = 'title' | 'subtitle' | 'section' | 'subsection';

interface HeadingProps extends React.HTMLAttributes<HTMLElement> {
  variant?: HeadingVariant;
}

const baseStyles = 'font-bold leading-tight';

// Mapping of variants to their respective tag and style
const variantStyles: Record<
  HeadingVariant,
  { tag: keyof JSX.IntrinsicElements; style: ClassValue }
> = {
  title: { tag: 'h1', style: 'text-3xl' },
  subtitle: { tag: 'h2', style: 'text-2xl' },
  section: { tag: 'h3', style: 'text-lg font-medium text-gray-600' },
  subsection: { tag: 'h4', style: 'text-base font-medium text-gray-600 ' },
};

const Heading: React.FC<HeadingProps> = ({
  variant = 'title',
  className,
  children,
  ...props
}) => {
  const { tag: Tag, style: variantStyle } = variantStyles[variant];
  const styles = cn(baseStyles, variantStyle, className);

  return (
    <Tag {...props} className={styles}>
      {children}
    </Tag>
  );
};

export default Heading;
